import { axiosInstance } from '@src/services/common';

export interface ShareConfigResponse {
  filter_config: {
    start_events: string[];
    end_event: string;
    include_events: string[];
    include_events_logic: 'every' | 'any';
    exclude_events: string[];
    hidden_events: string[];
    metadata: any[];
    time_range: [string, string];
    timeout_ms: number;
    limit: number;
    offset: number;
  };
  description: string;
  is_public: boolean;
  customer_id: string;
}

export interface SaveShareConfigPayload {
  filter_config: {
    start_events: string[];
    end_event: string;
    include_events: string[];
    include_events_logic: 'every' | 'any';
    exclude_events: string[];
    hidden_events: string[];
    metadata: any[];
    time_range: [string, string];
    timeout_ms: number;
    limit: number;
    offset: number;
  };
  description: string;
  is_public: boolean;
}

export interface SaveShareConfigResponse {
  share_id: string;
}

export async function getShareConfig(shareKey: string) {
  const response = await axiosInstance.get<ShareConfigResponse>(
    `/gm/v1/user_journeys/filters/${shareKey}`,
  );
  return response.data;
}

export async function saveShareConfig(payload: SaveShareConfigPayload) {
  const response = await axiosInstance.post<SaveShareConfigResponse>(
    '/gm/v1/user_journeys/filters/save',
    payload,
  );
  return response.data;
}
